<template>
  <app-stepper-section :label="label">

    <v-text-field :label="$t('message.admGenerics.message.responsibleName')"
                  v-model="name"
                  v-validate="required ? 'required' : undefined"
                  :name="secondary ?  $t('message.admGenerics.message.secondaryResponsibleName') : $t('message.admGenerics.message.responsibleName')"
                  :error-messages="errors.collect(secondary ?  $t('message.admGenerics.message.secondaryResponsibleName') : $t('message.admGenerics.message.responsibleName'))"></v-text-field>

    <v-text-field :label="$t('message.generics.message.phoneNumber')"
                  mask="(##) #####-####"
                  v-model="phone"
                  v-validate="required ? 'required' : undefined"
                  :name="secondary ? $t('message.admGenerics.message.secondaryPhoneNumber') : $t('message.generics.message.phoneNumber')"
                  :error-messages="errors.collect(secondary ? $t('message.admGenerics.message.secondaryPhoneNumber') : $t('message.generics.message.phoneNumber'))"></v-text-field>

    <v-text-field :label="$t('message.generics.message.email')"
                  v-model="email"
                  v-validate="required ? 'required' : undefined"
                  :name="secondary ? $t('message.admGenerics.message.secondaryEmail') : $t('message.generics.message.email')"
                  :error-messages="errors.collect(secondary ? $t('message.admGenerics.message.secondaryEmail') : $t('message.generics.message.email'))"></v-text-field>

  </app-stepper-section>
</template>

<script>
    import AppStepperSection from '../../../StepperSection'
    import userModalSection from '../mixins/user-modal-section'


    export default {
        components: {
            AppStepperSection,
        },

        props: {
            label: {
                type: String,
                required: true
            },

            value: {
                type: Object,
            },

            required: {
                type: Boolean,
                default: false
            },

            secondary: {
                type: Boolean,
                default: false
            },
        },

        mixins: [userModalSection],

        inject: {
            $validator: '$validator'
        },

        computed: {

            name: {
                get() {
                    return this.value.name
                },

                set(name) {
                    this.$emit('input', {...this.value, name})
                }
            },

            phone: {
                get() {
                    return this.value.phone
                },

                set(phone) {
                    this.$emit('input', {...this.value, phone})
                }
            },

            email: {
                get() {
                    return this.value.email
                },

                set(email) {
                    this.$emit('input', {...this.value, email})
                }
            },

        },
    }
</script>

<style scoped>
</style>
